import { Link } from '@tanstack/react-router';
import { Button } from '../components/ui/button';

const NotFoundPage = () => {
  return (
    <div className='flex min-h-screen w-full flex-col items-center justify-center bg-background px-6 text-start'>
      <div className='flex max-w-[600px] flex-col p-2'>
        <div className='mb-4 text-muted-foreground'>
          Powered by{' '}
          <a
            href='https://www.clientpaydirect.com/'
            target='_blank'
            className='font-bold'
          >
            <img
              src='/logo.svg'
              alt='Client Pay Direct'
              className='inline h-6'
            />
          </a>
        </div>

        <h1 className='animate-bounce text-[6rem] font-semibold text-primary-500 duration-1000'>
          404,
        </h1>
        <p className='text-lg text-muted-foreground'>
          Sorry, we couldn’t find the page you’re looking for.
        </p>

        <div className='mt-5'>
          <h2 className='text-xl font-semibold text-primary-500'>
            Did You Receive An Email?
          </h2>
          <ul className='mt-2 list-outside list-disc pl-10 text-muted-foreground'>
            <li>
              If you received an email, please use the unique link in that email
              by clicking the Get Started button.
            </li>
          </ul>
        </div>

        <div className='mt-8'>
          <h2 className='text-xl font-semibold text-primary-500'>
            Did You Receive A Letter?
          </h2>
          <ul className='mt-2 list-outside list-disc pl-10 text-muted-foreground'>
            <li>
              If you received a letter, navigate to{' '}
              <Link to='/' className='text-primary-600 underline'>
                claim.clientpaydirect.com
              </Link>
              .
            </li>
            <li>
              Enter the unique 6-digit alphanumeric code along with the ZIP code
              to start authentication.
            </li>
            <li>Select a payment method you like and claim your funds.</li>
          </ul>
        </div>

        <div className='mt-10 flex flex-col items-center gap-3'>
          <p>Having Trouble?</p>
          <Button variant='outline'>
            <a
              href='https://www.clientpaydirect.com/contact-us/'
              target='_blank'
            >
              Get Help
            </a>
          </Button>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
